class MwPageLoader extends HTMLElement {
  connectedCallback() {
    const root = document.documentElement;

    if (!root.classList.contains('mw-load-intro')) {
      this.remove();
      return;
    }

    const duration = this.#tokenDuration('--mw-dur-reveal', 560);
    const exitDuration = this.#tokenDuration('--mw-dur-ui', 240);
    const hardCap = duration + exitDuration + 400;

    window.setTimeout(() => {
      root.classList.add('mw-load-ready');

      window.setTimeout(() => {
        root.classList.remove('mw-load-intro', 'mw-load-ready');
        this.remove();
      }, exitDuration);
    }, duration);

    window.setTimeout(() => {
      root.classList.remove('mw-load-intro', 'mw-load-ready');
      this.remove();
    }, hardCap);
  }

  #tokenDuration(token, fallback) {
    const value = window.getComputedStyle(document.documentElement)
      .getPropertyValue(token)
      .trim();
    const parsed = Number.parseFloat(value);

    if (!Number.isFinite(parsed)) return fallback;
    return value.endsWith('s') && !value.endsWith('ms') ? parsed * 1000 : parsed;
  }
}

if (!customElements.get('mw-page-loader')) {
  customElements.define('mw-page-loader', MwPageLoader);
}
